/**
 * OrbDocCoreConceptsTraitsSLDocEx2DialView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsTraitsSLDocEx2Dial
 */

import { useOrbDocCoreConceptsTraitsSLDocEx2DialLogic } from '@/hooks/traits/useOrbDocCoreConceptsTraitsSLDocEx2DialLogic';
import type { OrbDocCoreConceptsTraitsSLDocEx2DialConfig } from '@/hooks/traits/useOrbDocCoreConceptsTraitsSLDocEx2DialLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsTraitsSLThermostat } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsTraitsSLDocEx2DialViewProps {
  config?: Partial<OrbDocCoreConceptsTraitsSLDocEx2DialConfig>;
}

export function OrbDocCoreConceptsTraitsSLDocEx2DialView({ config: propsConfig }: OrbDocCoreConceptsTraitsSLDocEx2DialViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsTraitsSLDocEx2DialLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsTraitsSLThermostat'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsTraitsSL" trait="OrbDocCoreConceptsTraitsSLDocEx2Dial">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="horizontal" gap="md" align="center"><Button label="Colder" action="OrbDocCoreConceptsTraitsSL.OrbDocCoreConceptsTraitsSLDocEx2Dial.DOWN" variant="secondary" /><Typography content={renderPatternValue([fields?.target, " °C"].join(''))} variant="h2" /><Button label="Warmer" action="OrbDocCoreConceptsTraitsSL.OrbDocCoreConceptsTraitsSLDocEx2Dial.UP" variant="secondary" /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsTraitsSLDocEx2DialView;
